import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20958 20958",
    style: {
      height: "1em",
      width: "1em"
    },
    className: "icon"
  }, React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2183.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8067 15477l9651 -9652m-9651 9652l-4826 -4826"
  }));
});